import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ELanguageCode } from '../../share/utils/enums/country.enum';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LanguageRedirectInterceptor {
  readonly #router = inject(Router);
  readonly #translate = inject(TranslateService);
  readonly #platformId = inject(PLATFORM_ID);
  #isRedirecting = false;

  constructor() {
    // Handle initial URL redirect before router processes it
    if (isPlatformBrowser(this.#platformId)) {
      const initialUrl = window.location.pathname;
      if (initialUrl.startsWith('/en/') || initialUrl === '/en') {
        this.#translate.setFallbackLang(ELanguageCode.EN);
        const pathWithoutEn = initialUrl.replace(/^\/en\/?/, '/');
        const redirectPath = pathWithoutEn || '/';
        // Update URL before Angular router processes it
        window.history.replaceState(
          null,
          '',
          redirectPath + window.location.search + window.location.hash
        );
      }
    }

    // Handle subsequent navigations
    this.#router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        if (this.#isRedirecting) {
          this.#isRedirecting = false;
          return;
        }

        const url = this.#router.url;
        if (url.startsWith('/en/') || url === '/en') {
          this.#translate.setFallbackLang(ELanguageCode.EN);
          const pathWithoutEn = url.replace(/^\/en\/?/, '/');
          const redirectPath = pathWithoutEn || '/';

          if (redirectPath !== url) {
            this.#isRedirecting = true;
            this.#router.navigateByUrl(redirectPath, { replaceUrl: true });
          }
        }
      });
  }
}
